/**
 * P0-DISCOVERY-01 — small event bus so any surface (PremiumGoal,
 * NationOvertake, PredictionCard correct, DailyWow, TopFanWeekly)
 * can ask the global VictoryCardPrompt to surface itself.
 *
 * The prompt is non-blocking: expanded UI for 8s, then auto-collapses
 * into a compact pill. It NEVER auto-opens the ShareSheet or pushes
 * the user to /viral-cards — those are user-initiated actions.
 */
import { trackEvent } from "@/lib/audit";

export type VictoryPromptSource =
  | "prediction_correct"
  | "nation_overtake"
  | "premium_goal"
  | "top_fan_weekly"
  | "daily_wow";

export interface VictoryPromptDetail {
  source: VictoryPromptSource;
  headline?: string;
  subline?: string;
}

const EVENT = "vs:victory:prompt";

export function fireVictoryPrompt(detail: VictoryPromptDetail): void {
  if (typeof window === "undefined") return;
  void trackEvent("victory_card_prompt_shown", { source: detail.source });
  window.dispatchEvent(new CustomEvent<VictoryPromptDetail>(EVENT, { detail }));
}

export function subscribeVictoryPrompt(
  handler: (detail: VictoryPromptDetail) => void,
): () => void {
  if (typeof window === "undefined") return () => {};
  const fn = (e: Event) => {
    const d = (e as CustomEvent<VictoryPromptDetail>).detail;
    if (d) handler(d);
  };
  window.addEventListener(EVENT, fn as EventListener);
  return () => window.removeEventListener(EVENT, fn as EventListener);
}
